<template>
  <div class="fire-over-view">
    <div class="fire-over-view-top-line">
      <div class="fire-over-view-top-line-box" style="background:linear-gradient(#FF6666, #FF666699);">
        <i class="iconfont el-icon-damai-baojingjingbao2"></i>
        <div class="fire-over-view-top-line-box-info">
          <div class="fire-over-view-top-line-box-num">{{monthAlarmRecordNumber}}</div>
          <div class="fire-over-view-top-line-box-tip">本月报警数</div>
        </div>
      </div>
      <div class="fire-over-view-top-line-box" style="background:linear-gradient(#1DCBBB, #1DCBBB99);">
        <i class="iconfont el-icon-damai-xiaojing"></i>
        <div class="fire-over-view-top-line-box-info">
          <div class="fire-over-view-top-line-box-num">{{monthAlarmReleaseNumber}}</div>
          <div class="fire-over-view-top-line-box-tip">本月消警数</div>
        </div>
      </div>
      <div class="fire-over-view-top-line-box" style="background:linear-gradient(#3E78F4, #3E78F499);">
        <i class="iconfont el-icon-damai-shebei2"></i>
        <div class="fire-over-view-top-line-box-info">
          <div class="fire-over-view-top-line-box-num">{{deviceTotalNumber}}</div>
          <div class="fire-over-view-top-line-box-tip">设备总数</div>
        </div>
      </div>
      <div class="fire-over-view-top-line-box" style="background:linear-gradient(#FF9F72, #FF9F7299);">
        <i class="iconfont el-icon-damai-lixianshebeishuliang"></i>
        <div class="fire-over-view-top-line-box-info">
          <div class="fire-over-view-top-line-box-num">{{deviceOfflineNumber}}</div>
          <div class="fire-over-view-top-line-box-tip">设备异常数</div>
        </div>
      </div>
    </div>

    <div class="fire-over-view-record-line">
      <div class="fire-over-view-record-line-item">
        <el-card class="box-card" style="height: 100%;">
          <div slot="header" class="clearfix">
            <span style="font-weight: 600;">消防报警记录</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="pageJump('fire-control-call-police-record')">更多<i class="iconfont el-icon-damai-left-double-arrow" style="font-size: 12px;"></i></el-button>
          </div>
          <div class="fire-over-view-record-line-item-info-line" v-for="(record, recordIndex) in fcsAlarmRecordList" :key="recordIndex">
            <div style="width: 20%;">{{record.deviceTypeText || '--'}}</div>
            <div style="width: 60%;">{{record.deviceName}}</div>
            <div style="width: 20%;color: #67C23A" v-if="record.alarmReleaseTime"><i class="iconfont el-icon-damai-dui"></i>已解除</div>
            <div style="width: 20%;color: #F56C6C" v-else><i class="iconfont el-icon-damai-gaojing"></i>报警中</div>
          </div>
        </el-card>
      </div>

      <div class="fire-over-view-record-line-item">
        <el-card class="box-card" style="height: 100%;">
          <div slot="header" class="clearfix">
            <span style="font-weight: 600;">设备异常记录</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="pageJump('fire-control-device-state-record')">更多<i class="iconfont el-icon-damai-left-double-arrow" style="font-size: 12px;"></i></el-button>
          </div>
          <div class="fire-over-view-record-line-item-info-line" v-for="(record, recordIndex) in fireDeviceStatusList" :key="recordIndex">
            <div style="width: 40%;">{{record.deviceName}}</div>
            <div style="width: 30%;">{{record.deviceChangeStatusText}}</div>
            <div style="width: 30%;">{{record.changeTime}}</div>
<!--            <div style="width: 20%;color: #67C23A" v-if="record.alarmReleaseTime"><i class="iconfont el-icon-damai-dui"></i>已解除</div>-->
<!--            <div style="width: 20%;color: #F56C6C" v-else><i class="iconfont el-icon-damai-gaojing"></i>报警中</div>-->
          </div>
        </el-card>
      </div>
    </div>

<!--    <div class="fire-over-view-line" style="height: 280px;align-items: center">-->
<!--      <div style="width: 18%;border: 1px solid #eeeeee;border-radius: 10px;padding: 20px 0;">-->
<!--        <common-ring commonRingId="deviceGatewayRing" :height="'200px'" :colorList="onlineColorList" :ringLegend="commonRingLegend" :ringTitle='deviceGatewayTitle' :ringData='deviceGatewayInfo' />-->
<!--      </div>-->
<!--      <div style="width: 18%;border: 1px solid #eeeeee;border-radius: 10px;padding: 20px 0;">-->
<!--        <common-ring commonRingId="waterLevelDeviceRing" :height="'200px'" :colorList="onlineColorList" :ringLegend="commonRingLegend" :ringTitle='waterLevelDeviceTitle' :ringData='waterLevelDeviceInfo' />-->
<!--      </div>-->
<!--      <div style="width: 18%;border: 1px solid #eeeeee;border-radius: 10px;padding: 20px 0;">-->
<!--        <common-ring commonRingId="waterPressureDeviceRing" :height="'200px'" :colorList="onlineColorList" :ringLegend="commonRingLegend" :ringTitle='waterPressureDeviceTitle' :ringData='waterPressureDeviceInfo' />-->
<!--      </div>-->
<!--      <div style="width: 18%;border: 1px solid #eeeeee;border-radius: 10px;padding: 20px 0;">-->
<!--        <common-ring commonRingId="transmissionDeviceRing" :height="'200px'" :colorList="onlineColorList" :ringLegend="commonRingLegend" :ringTitle='transmissionDeviceTitle' :ringData='transmissionDeviceInfo' />-->
<!--      </div>-->
<!--      <div style="width: 18%;border: 1px solid #eeeeee;border-radius: 10px;padding: 20px 0;">-->
<!--        <common-ring commonRingId="pointPositionDeviceRing" :height="'200px'" :colorList="onlineColorList" :ringLegend="commonRingLegend" :ringTitle='pointPositionDeviceTitle' :ringData='pointPositionDeviceInfo' />-->
<!--      </div>-->
<!--    </div>-->

    <div class="finance-over-view-line" style="height: 280px;margin: 60px 0 20px 0;padding: 10px;position: relative;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);border-radius: 5px;">
      <chart-time-select @getData="getFcsStatistics" />
      <common-line style="z-index: 1000" lineId='fireAccessRecordLine' :height='"260px"' :lineTitle='fireAccessRecordTitle' :legendData="fireAccessRecordLegendData" :xAxis="fireAccessRecordXAxis" :yAxis='fireAccessRecordYAxis' :series='fireAccessRecordSeries' />
    </div>

  </div>

</template>

<script>
  import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
  import {api} from '../../api/FireControl'
  import {errorHandler} from '../../../utils/errorHandler'
  import CommonLine from '../../../components/Echarts/Line/commonLine'
  import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";

  export default {
    components: {
      ChartTimeSelect,
      CommonLine,
      CommonRing},
    name: 'fire-over-view',
    data () {
      return {
        monthAlarmRecordNumber: 0,
        monthAlarmReleaseNumber: 0,
        deviceTotalNumber: 0,
        deviceOfflineNumber: 0,
        fcsAlarmRecordList: [],
        fireDeviceStatusList: [],

        onlineColorList: ['#44c23b', '#f54659'],
        commonRingLegend: {
          left: 'center',
          bottom: -5,
        },
        deviceGatewayTitle: '网关设备状态',
        waterLevelDeviceTitle: '液位设备状态',
        waterPressureDeviceTitle: '液压设备状态',
        transmissionDeviceTitle: '用传设备状态',
        pointPositionDeviceTitle: '点位设备状态',
        deviceGatewayInfo: [],
        waterLevelDeviceInfo: [],
        waterPressureDeviceInfo: [],
        transmissionDeviceInfo: [],
        pointPositionDeviceInfo: [],


        fireColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC', '#47C4CA', '#77E5BF', '#82D74C', '#A4C344'],
        fireTitle: '消息推送数量',
        fireInfo: [],

        fireAccessRecordRadio: false,
        fireAccessRecordTitle: '报警统计',
        fireAccessRecordLegendData: [],
        fireAccessRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        fireAccessRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            splitLine: {
              show: false
            },
          }
        ],
        fireAccessRecordSeries: [],

      }
    },
    created () {
      this.getMonthAlarmRecord()
      this.getDeviceStatus()
      this.getFcsAlarmRecordPage()
      this.getFireDeviceStatusPage()
    },
    mounted () {
      this.getFcsDeviceStatistics()
    },
    methods: {
      // 月报警数
      getMonthAlarmRecord () {
        this.$axios.get(api.getFcsDeviceStatistics, {})
          .then(res => {
            let data = res.data.data
            this.monthAlarmRecordNumber = data.monthAlarmRecordNumber
            this.monthAlarmReleaseNumber = data.monthAlarmReleaseNumber
          })
          .catch(errorHandler('获取报警信息失败'))
      },

      // 设备统计
      getDeviceStatus () {
        this.$axios.get(api.getDeviceStatus, {})
          .then(res => {
            let data = res.data.data
            this.deviceTotalNumber = data.deviceTotalNumber
            this.deviceOfflineNumber = data.deviceOfflineNumber
          })
          .catch(errorHandler('获取设备信息失败'))
      },

      // 获取报警记录
      getFcsAlarmRecordPage () {
        this.$axios.post(api.getFcsAlarmRecordPage, {
          pageSize: 5,
          pageNum: 1,
        })
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.deviceType === '1') {
                v.deviceTypeText = '液位报警'
              } else if (v.deviceType === '2') {
                v.deviceTypeText = '液压报警'
              } else if (v.deviceType === '3') {
                v.deviceTypeText = '烟感报警'
              } else if (v.deviceType === '4') {
                v.deviceTypeText = '温感报警'
              } else if (v.deviceType === '5') {
                v.deviceTypeText = '手动报警'
              }
            })
            this.fcsAlarmRecordList = data
          })
          .catch(errorHandler('获取报警记录失败'))
      },

      // 获取设备在离线记录
      getFireDeviceStatusPage () {
        this.$axios.post(api.getFireDeviceStatusPage, {
          pageSize: 5,
          pageNum: 1,
          deviceChangeStatus: '0'
        })
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.deviceChangeStatus === '0') {
                v.deviceChangeStatusText = '在线-->离线'
              } else if (v.deviceChangeStatus === '1') {
                v.deviceChangeStatusText = '离线-->在线'
              } else if (v.deviceChangeStatus === '2') {
                v.deviceChangeStatusText = '注册成功'
              }
            })
            this.fireDeviceStatusList = data
          })
          .catch(errorHandler('获取记录失败'))
      },

      getFcsDeviceStatistics () {
        this.$axios.get(api.getFcsDeviceStatistics, {})
          .then(res => {
            let data = res.data.data
            this.deviceGatewayInfo = [
              {name: '在线', value: data.deviceGatewayOnlineNumber },
              {name: '离线', value: data.deviceGatewayOfflineNumber }
            ]
            this.waterLevelDeviceInfo = [
              {name: '在线', value: data.waterLevelDeviceOnlineNumber },
              {name: '离线', value: data.waterLevelDeviceOfflineNumber }
            ]
            this.waterPressureDeviceInfo = [
              {name: '在线', value: data.waterPressureDeviceOnlineNumber },
              {name: '离线', value: data.waterPressureDeviceOfflineNumber }
            ]
            this.transmissionDeviceInfo = [
              {name: '在线', value: data.userTransforDeviceOnlineNumber },
              {name: '离线', value: data.userTransforDeviceOfflineNumber }
            ]
            this.pointPositionDeviceInfo = [
              {name: '在线', value: data.pointDeviceOnlineNumber },
              {name: '离线', value: data.pointDeviceOfflineNumber }
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      getFcsStatistics (type, startTime, endTime) {
        this.$axios.post(`${api.getFcsStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY'
        })
          .then(res => {
            let data = res.data.data
            let xData = []
            let seriesData = []
            data.map(v => {
              seriesData.push(v.alarmTotalTimes)
              if (type === 1) {
                let dateArr = v.time.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.time)
              }
            })
            this.fireAccessRecordXAxis.data = xData
            this.fireAccessRecordSeries = [
              {
                name: '',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: seriesData
              },

            ]
          })
          .catch(errorHandler('获取数据失败'))
      },
      pageJump (name) {
        this.$router.push({
          name: name
        })
      }
    },
    watch: {}

  }
</script>


<style lang="less">
  .fire-over-view {
    padding: 20px 2%;
    .fire-over-view-top-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .fire-over-view-top-line-box {
        width: 20%;
        height: 140px;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #FFFFFF;
        i {
          width: 40%;
          font-size: 48px;
        }
        .fire-over-view-top-line-box-info {
          flex: 1;
          text-align: left;
          .fire-over-view-top-line-box-num {
            font-size: 48px;
            font-weight: 600;
          }
        }
      }
    }
    .fire-over-view-record-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 40px 0;
      text-align: left;
      .fire-over-view-record-line-item {
        width: 46.67%;
        height: 303px;
        .fire-over-view-record-line-item-info-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 0 20px 0;
          div {
            padding: 0 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .fire-over-view-line {
      display: flex;
      justify-content: space-between;
      .fire-person-count-box {
        width: 200px;
        height: 80px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .fire-person-count {
          font-size: 32px;
          font-weight: 500;
        }
        .fire-person-tip {
          font-size: 14px;
        }
      }
      .fire-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .fire-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/FireControl/FireControlOverView/FireControlOverView.vue